import { t } from '@/i18n';

export default {
  required: (value: any) => !!value || t('validation.required'),
  choice2: (value: any) => value.length === 2 || t('validation.choice2'),
  counter: (value: any) => value.length <= 20 || t('validation.counter'),
  counter2: (value: any) => (!!value && value.length === 2) || t('validation.counter2'),
  counter3: (value: any) => (!!value && value.length === 3) || t('validation.counter3'),
  counterMin4: (value: any) => (!!value && value.length <= 4) || t('validation.counterMin4'),
  counter14to16: (value: any) => (!!value && value.length >= 14 && value.length <= 16) || t('validation.counter14to16'),
  counter100: (value: any) => (!value || typeof(value) === 'string' && value.length <= 100) || t('validation.counter100'),
  counter500: (value: any) => (!value || typeof(value) === 'string' && value.length <= 500) || t('validation.counter500'),
  counter1000: (value: any) => (!value || typeof(value) === 'string' && value.length <= 1000) || t('validation.counter1000'),
  typeNumber: (value: any) => (!value || typeof(value) === 'number' && value < -2147483648 && value > 2147483647) || t('validation.typeNumber'),
  typeStringNumber: (value: any) => {
    const pattern = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
    return pattern.test(value) || t('validation.typeStringNumber');
  },
  email: (value: any) => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || t('validation.email');
  },
  phoneNumber: (value: any) => {
    if (value === null || value === '') { return true; }
    const pattern = /0\d{1,4}-\d{1,4}-\d{4}/;
    return pattern.test(value) || t('validation.phoneNumber');
  },
  postalCode: (value: any) => {
    if (value === null || value === '') { return true; }
    const pattern = /[0-9]{3}-[0-9]{4}/;
    return pattern.test(value) || t('validation.postalCode');
  },
  integerThan0: (value: any) => {
    const pattern = /^\d*$/;
    return pattern.test(value) || t('validation.integerThan0');
  },
  multipleSelectRequired: (value: []) => value.length > 0 || t('validation.multipleSelectRequired'),
  typeKana: (value: any) => {
    if (!value) { return true; }
    const pattern = /^[\u30a1-\u30f6]+$/;
    return pattern.test(value) || t('validation.typeKana');
  },
  typeKanaFullWidth: (value: any) => {
    if (!value) return true;
    const pattern = /^[ァ-ヶー　]+$/;
    return pattern.test(value) || t('validation.typeKanaFullWidth');
  },
  typeHiraganaFullWidth: (value: any) => {
    if (!value) return true;
    const pattern = /^[ぁ-ゖー　]+$/;
    return pattern.test(value) || t('validation.typeHiraganaFullWidth');
  },
  typeAlphabet: (value: any) => {
    if (!value) { return true; }
    const pattern = /^[a-zA-Z\s]*$/;
    return pattern.test(value) || t('validation.typeAlphabet');
  },
};